import React, { useContext, useRef, useState } from 'react'
import { FileInfo, FileName, HiddenInput, RemoveButton, UploadArea, UploadContainer, UploadContent, UploadIcon, UploadText } from './style'
import { FileUp, X } from 'lucide-react'
import CertificatesContext from '../../../../../contexts/CertificatesContext'

const SupplierFileComponent = () => {
  const { certificate, setCertificate } = useContext(CertificatesContext)
  const [ isDragActive, setIsDragActive ] = useState(false)
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileSelect = (file: File) => {
    if (file && file.type === 'application/pdf') {
      setCertificate(prev => ({
        ...prev,
        supplierFile: file
      }))
    } else {
      alert('Somente arquivos do tipo PDF podem ser carregados.')
    }
  }

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault()
    setIsDragActive(false)
    
    const file = e.dataTransfer.files[0]
    handleFileSelect(file)
  }

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault()
    setIsDragActive(true)
  }

  const handleDragLeave = () => {
    setIsDragActive(false)
  }

  const handleClick = () => {
    fileInputRef.current?.click()
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      handleFileSelect(e.target.files[0])
    }
  }

  const handleRemove = () => {
    setCertificate((prev:any) => ({
      ...prev,
      supplierFile: null
    }))
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }
  
  return(
    <UploadContainer>
      <UploadArea
        isDragActive={isDragActive}
        hasFile={!!certificate.supplierFile}
        onClick={handleClick}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
      >
        <HiddenInput
          ref={fileInputRef}
          type="file"
          accept=".pdf"
          onChange={handleChange}
        />
        
        {certificate.supplierFile ? (
          <>
            <UploadContent hasFile>
              <UploadIcon hasFile>
                <FileUp />
              </UploadIcon>
              <UploadText hasFile>
                {certificate.supplierFile.name}
              </UploadText>
            </UploadContent>
            <RemoveButton onClick={handleRemove}>
              <X size={16} />
            </RemoveButton>
          </>
        ) : (
          <UploadContent>
            <UploadIcon>
              <FileUp />
            </UploadIcon>
            <UploadText>
              Certificado do fornecedor
              <br />
              Somente PDF
            </UploadText>
          </UploadContent>
        )}
      </UploadArea>
    </UploadContainer>
  )
}

export default SupplierFileComponent